import Swiper, { Autoplay, FreeMode } from 'swiper';

Swiper.use([Autoplay, FreeMode]);

const seedsSlider = () => {
  const selectors = {
    slider: '.js-seeds-slider',
  };

  const swiperContainer = document.querySelector(selectors.slider);

  if (!swiperContainer) return;

  const swiper = new Swiper(swiperContainer, {
    slidesPerView: 'auto',
    centeredSlides: true,
    loop: true,
    spaceBetween: 16,
    speed: 2500,
    autoplay: {
      delay: 1,
    },
    freeMode: true,
    allowTouchMove: false,
    disableOnInteraction: false,
    simulateTouch: false,

    breakpoints: {
      768: {
        spaceBetween: 40,
      },
    },
  });
};

export default seedsSlider;
